import * as React from "react";
import "./style.scss";
import Button from "../../../core/Button";
import { Icon, Modal } from "antd";

interface ConfirmationModalProps {
  className: string;
  titleText: string;
  bodyText: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  onPrimaryButton?: any;
  onSecondaryButton?: any;
  visible: boolean;
}

class ConfirmationModal extends React.Component<ConfirmationModalProps, {}> {
  onPrimaryButton() {
    if (this.props.onPrimaryButton) {
      this.props.onPrimaryButton();
    }
    this.setState({ visible: false });
  }

  onSecondaryButton() {
    if (this.props.onSecondaryButton) {
      this.props.onSecondaryButton();
    }
    this.setState({ visible: false });
  }

  render() {
    const { primaryButtonText, secondaryButtonText } = this.props;
    return (
      <div>
        <Modal
          visible={this.props.visible}
          wrapClassName={`${this.props.className} confirmation-modal`}
          closable={false}
          width={416}
          footer={[
            <Button
              key="close"
              className="ant-btn-secondary"
              onClick={this.onSecondaryButton.bind(this)}
              data-automation-id={`confirmation-modal-${secondaryButtonText.toLowerCase()}`}
            >
              {secondaryButtonText}
            </Button>,
            <Button
              key="confirm"
              type="primary"
              onClick={this.onPrimaryButton.bind(this)}
              data-automation-id={`confirmation-modal-${primaryButtonText.toLowerCase()}`}
            >
              {primaryButtonText}
            </Button>
          ]}
        >
          <div className="ant-confirm-body">
            <Icon
              type="question-circle"
              style={{ fontSize: 24, color: "#ffbf00" }}
            />
            <span className="ant-confirm-title">{this.props.titleText}</span>
            <div className="ant-confirm-content">{this.props.bodyText}</div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./client/modules/core/Modal/ConfirmationModal/index.tsx